// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"42a9c3b7","211":"6188e1f9","453":"bfdc4da8"}[chunkId] + ".chunk.js";
};